import type { ReactNode } from 'react'

import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'styled-components'

import { Colors } from '@b-stock/fe-core/design-system'

const Banner = styled.div`
  align-items: center;
  background: ${Colors.Semantic.Info.background};
  border-top: 0.0625rem solid
    color-mix(in srgb, ${Colors.Semantic.Info.onhover} 25%, transparent);
  color: ${Colors.Semantic.Info.onclick};
  display: flex;
  font-size: 0.8125rem;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
`

const Icon = styled(FontAwesomeIcon)`
  flex-shrink: 0;
  font-size: 1rem;
  margin: 0.125rem 0;
`

export const CardFooterNote = ({
  icon = faCircleInfo,
  children,
}: {
  icon?: IconDefinition
  children: ReactNode
}) => (
  <Banner role="note">
    <Icon icon={icon} />
    {children}
  </Banner>
)
